"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var Slide = function (_a) {
    var games = _a.games, gameCardPlaceholder = _a.gameCardPlaceholder;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.gamesContainer, " games-container") }, games.map(function (item) {
        var _a;
        return (react_1.default.createElement(ui_components_1.DesktopGameCard, { key: item.id, title: item.title, gameId: item.id, slug: item.slug, withDemo: (_a = item === null || item === void 0 ? void 0 : item.settings) === null || _a === void 0 ? void 0 : _a['demo'], gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL }));
    })));
};
exports.default = Slide;
